export const selectReducer = (state) => state.cmsMenu;

export const selectMenuInfo = (state) =>
  selectReducer(state) ? selectReducer(state).get('menuInfo') : undefined;
